import { Item } from './item.model';
import { Observable } from 'rxjs';

export class Stop {

    fk_experience?: number;
    stop?: string;
    items?: Item[];

    constructor() {  }

}